import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { routes } from './routes.config';
import { ProtectedRoute } from './ProtectedRoute';
import { LoadingSpinner } from '@/shared/components/ui/LoadingSpinner';
import { NotFoundPage } from '@/shared/components/pages/NotFoundPage';

export function AppRoutes() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><LoadingSpinner size="lg" /></div>}>
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.auth ? (
                <ProtectedRoute>
                  <route.element />
                </ProtectedRoute>
              ) : (
                <route.element />
              )
            }
          />
        ))}
        {/* Catch-all 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export { ProtectedRoute } from './ProtectedRoute';
export {
  routes,
  organisationSubRouteGroups,
  getOrganisationSubRouteGroups,
  getOrganisationSubRoutes,
  userSubRoutes,
} from './routes.config';
export type { SubRouteItem, SubRouteGroup } from './routes.config';
